import { PROVINCES } from '@/utils/constants';

/**
 * Government published LIF Maximum rates
 * Will be stored in database in CST-7
 * https://capintel.atlassian.net/browse/CST-7
 */

const LIF_MAX_FEDERAL: Record<number, number> = {
  50: 4.95,
  51: 4.98,
  52: 5.02,
  53: 5.07,
  54: 5.11,
  55: 5.16,
  56: 5.22,
  57: 5.27,
  58: 5.34,
  59: 5.41,
  60: 5.48,
  61: 5.56,
  62: 5.65,
  63: 5.75,
  64: 5.86,
  65: 5.98,
  66: 6.11,
  67: 6.25,
  68: 6.41,
  69: 6.6,
  70: 6.8,
  71: 7.03,
  72: 7.29,
  73: 7.59,
  74: 7.93,
  75: 8.33,
  76: 8.79,
  77: 9.32,
  78: 9.94,
  79: 10.68,
  80: 11.57,
  81: 12.65,
  82: 14.01,
  83: 15.75,
  84: 18.09,
  85: 21.36,
  86: 26.26,
  87: 34.45,
  88: 50.83,
  89: 100.0,
  90: 100.0,
  91: 100.0,
  92: 100.0,
  93: 100.0,
  94: 100.0,
  95: 100.0,
};

const LIF_MAX_ON_NB_SK_NL_BC_AB: Record<number, number> = {
  50: 6.27,
  51: 6.31,
  52: 6.35,
  53: 6.4,
  54: 6.45,
  55: 6.51,
  56: 6.57,
  57: 6.63,
  58: 6.7,
  59: 6.77,
  60: 6.85,
  61: 6.94,
  62: 7.04,
  63: 7.14,
  64: 7.26,
  65: 7.38,
  66: 7.52,
  67: 7.67,
  68: 7.83,
  69: 8.02,
  70: 8.22,
  71: 8.45,
  72: 8.71,
  73: 9.0,
  74: 9.34,
  75: 9.71,
  76: 10.15,
  77: 10.66,
  78: 11.25,
  79: 11.96,
  80: 12.82,
  81: 13.87,
  82: 15.19,
  83: 16.9,
  84: 19.19,
  85: 22.4,
  86: 27.23,
  87: 35.29,
  88: 51.46,
  89: 100.0,
  90: 100.0,
  91: 100.0,
  92: 100.0,
  93: 100.0,
  94: 100.0,
  95: 100.0,
};

const LIF_MAX_QC_MB_NS: Record<number, number> = {
  50: 6.1,
  51: 6.1,
  52: 6.1,
  53: 6.1,
  54: 6.1,
  55: 6.4,
  56: 6.5,
  57: 6.5,
  58: 6.6,
  59: 6.7,
  60: 6.7,
  61: 6.8,
  62: 6.9,
  63: 7.0,
  64: 7.1,
  65: 7.2,
  66: 7.3,
  67: 7.4,
  68: 7.6,
  69: 7.7,
  70: 7.9,
  71: 8.1,
  72: 8.3,
  73: 8.5,
  74: 8.8,
  75: 9.1,
  76: 9.4,
  77: 9.8,
  78: 10.3,
  79: 10.8,
  80: 11.5,
  81: 12.1,
  82: 12.9,
  83: 13.8,
  84: 14.8,
  85: 16.0,
  86: 17.3,
  87: 18.9,
  88: 20.0,
  89: 20.0,
  90: 20.0,
  91: 20.0,
  92: 20.0,
  93: 20.0,
  94: 20.0,
  95: 20.0,
};

const LIF_MAX_RATES = Object.freeze({
  [PROVINCES.AB]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.BC]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.FEDERAL]: LIF_MAX_FEDERAL,
  [PROVINCES.MB]: LIF_MAX_QC_MB_NS,
  [PROVINCES.NT]: LIF_MAX_FEDERAL, // Defaulting to Federal values for NT
  [PROVINCES.NB]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.NL]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.NS]: LIF_MAX_QC_MB_NS,
  [PROVINCES.NU]: LIF_MAX_FEDERAL, // Defaulting to Federal values for NU
  [PROVINCES.ON]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.PE]: LIF_MAX_FEDERAL, // Defaulting to Federal values for PE
  [PROVINCES.QC]: LIF_MAX_QC_MB_NS,
  [PROVINCES.SK]: LIF_MAX_ON_NB_SK_NL_BC_AB,
  [PROVINCES.YT]: LIF_MAX_FEDERAL, // Defaulting to Federal values for YT
});

const getLIFMaxRates = () =>
  // Hard-coded values for now, to be updated in CST-7
  // https://capintel.atlassian.net/browse/CST-5
  LIF_MAX_RATES;
export default getLIFMaxRates;
